<template>
  <div class="container_box">
    <div class="advertising_box">
      <div class="advertising_box_item" v-for="(item,index) in advertisingList" :key="index">
        <div class="title_box">
          <h2 class="title">{{ item.advertisementTitle }}</h2>
          <Button v-if="getPermission('ymsAdvertisement_detail') || getPermission('ymsAdvertisement_update')"
            type="primary" @click="editBtn(item)">{{ $t('key1000985') }}</Button>
        </div>
        <!--轮播图-->
        <div class="rotationChart_box" v-if="item.orientationType === 1">
          <Carousel
            :autoplay="setting.autoplay"
            :autoplay-speed="setting.autoplaySpeed"
            :dots="setting.dots"
            :radius-dot="setting.radiusDot"
            :trigger="setting.trigger"
            :loop="setting.loop"
            :arrow="setting.arrow">
            <CarouselItem v-for="(ele,idx) in item.ymsAdvertisementDetailBos" :key="idx">
              <div class="banner_img_box">
                <img class="banner_img" v-if="ele.imagePath" :src="setImgPath(ele.imagePath)" @error="setErrorImg($event)"/>
                <div v-else class="design_sketch_styles"> {{ $t('key1005044') + (idx + 1) }}</div>
              </div>
            </CarouselItem>
          </Carousel>
        </div>
        <!--金刚区-->
        <div class="img_box" v-if="item.orientationType === 4">
          <div class="img_list_styles">
            <div class="img_list_styles_item" v-for="(ele, idx) in item.ymsAdvertisementDetailBos" :key="idx">
              <img :src="setImgPath(ele.imagePath)" @error="setErrorImg($event)" alt=""/>
              <h3 class="title">{{ ele.name }}</h3>
            </div>
          </div>
        </div>
        <div class="img_box" v-if="![1,4].includes(item.orientationType)">
          <span class="basic_title">{{ $t('key1005073') }}</span>
          <img class="img_styles" :src="setImgPath(item.ymsAdvertisementDetailBos[0].imagePath)" @error="setErrorImg($event)" alt=""/>
        </div>
        <Row type="flex" :gutter="gutterItem" v-if="![1,4].includes(item.orientationType)">
          <Col :span="ItemCol" class="basic_item">
            <span class="basic_title">{{ $t('key1005042') }}</span>
            <span class="basic_txt" :title="item.jumpTargetName">{{ item.jumpTargetName }}</span>
          </Col>
          <Col :span="ItemCol" class="basic_item">
            <span class="basic_title">{{ $t('key1002164') }}</span>
            <i-switch v-model="item.status" :before-change="handleBeforeChange.bind(this, item.ymsAdvertisementId)"
              :true-value="1" :false-value="0" :disabled="!getPermission('ymsAdvertisement_updateStatus')"></i-switch>
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import api from '@/api/';
import {_handleMultilingualFields} from "@/utils/common";

export default {
  name: "advertisingManage",
  mixins: [Mixin],
  data() {
    return {
      ItemCol: 24,
      originalData: [
        {
          advertisementTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005067'),
          orientationType: 1,
          status: 0,
          path: '/rotationChart',
          ymsAdvertisementDetailBos: [
            {
              imagePath: '',
              jumpTargetType: null,
              jumpTargetValue: '',
              jumpTargetName: ''
            }
          ],
        },
        {
          advertisementTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005045'),
          orientationType: 4,
          status: 0,
          path: '/vajraDistrict',
          ymsAdvertisementDetailBos: [
            {
              imagePath: '',
              jumpTargetType: null,
              jumpTargetValue: '',
              jumpTargetName: ''
            }
          ],
        },
        {
          advertisementTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005068'),
          orientationType: 0,
          status: 0,
          path: '/topAdvertisingSpace',
          ymsAdvertisementDetailBos: [
            {
              imagePath: '',
              jumpTargetType: null,
              jumpTargetValue: '',
              jumpTargetName: ''
            }
          ],
        },
        {
          advertisementTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005069'),
          orientationType: 3,
          status: 0,
          path: '/sideAdvertisingSpace',
          ymsAdvertisementDetailBos: [
            {
              imagePath: '',
              jumpTargetType: null,
              jumpTargetValue: '',
              jumpTargetName: ''
            }
          ],
        },
        {
          advertisementTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005070'),
          orientationType: 2,
          status: 0,
          path: '/infoAdvertisingSpace',
          ymsAdvertisementDetailBos: [
            {
              imagePath: '',
              jumpTargetType: null,
              jumpTargetValue: '',
              jumpTargetName: ''
            }
          ],
        },
      ],
      advertisingList: [],
      setting: {
        autoplay: false,
        autoplaySpeed: 4000,
        dots: 'outside',
        radiusDot: true,
        trigger: 'click',
        arrow: 'always',
        loop: false
      },
    };
  },
  created() {
    this.getAdvertisingData();
  },
  methods: {
    // 获取广告列表数据
    getAdvertisingData() {
      const v = this;
      // 无权限直接跳转
      if (!v.getPermission('ymsAdvertisement_query')) {
        v.gotoError();
        return;
      }
      v.advertisingList = [];
      v.axios.get(api.get_ymsAdvertisement).then(response => {
        const { code, datas } = response.data || {};
        const list = Array.isArray(datas) ? datas : [];
        if (code !== 0) return;
        // 没有广告数据时，直接使用原始数据
        if (!list.length) {
          v.advertisingList = JSON.parse(JSON.stringify(v.originalData || []));
          return;
        }
        // 先处理接口返回的广告数据
        const formattedData = datas.map(item => {
          const detailList = item.ymsAdvertisementDetailBos || [];
          const keylist = ['imagePath', 'name'];
          return {
            ...item,
            advertisementTitle: _handleMultilingualFields(item.advertisementTitle),
            ymsAdvertisementDetailBos: detailList.length ? v.handleMultilinguaTableFields(detailList, keylist) : []
          };
        });
        // 按 orientationType 建立映射，方便快速匹配
        const advertisementMap = new Map();
        formattedData.forEach(item => {
          advertisementMap.set(item.orientationType, item);
        });
        // 按 originalData 顺序组装最终数据
        v.advertisingList = v.originalData.map(item => {
          const matchedItem = advertisementMap.get(item.orientationType);
          // 没有匹配到接口数据时，保留原始项
          if (!matchedItem) {
            return {...item};
          }
          const firstDetail = (matchedItem.ymsAdvertisementDetailBos || [])[0] || {};
          return {
            ...matchedItem,
            path: item.path,
            jumpTargetName: firstDetail.jumpTargetName || ''
          };
        });
      });
    },
    // 编辑按钮
    editBtn(item) {
      this.$router.push({
        path: item.path,
        query: {
          ymsAdvertisementId: item.ymsAdvertisementId
        }
      });
    },
    // 启用、停用
    handleBeforeChange(ymsAdvertisementId) {
      let v = this;
      return new Promise((resolve) => {
        if (ymsAdvertisementId) {
          v.$Modal.confirm({
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005071'),
            content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005072'),
            okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000543'),
            onOk: () => {
              resolve();
              v.axios.put(api.put_ymsAdvertisement_updateStatus + ymsAdvertisementId, '', {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
                if (response.data.code === 0) {
                  v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
                  v.getAdvertisingData();
                }
              });
            },
            onCancel: () => {
            }
          });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.advertising_box {
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  .advertising_box_item {
    width: 525px;
    height: 300px;
    background-color: #fff;
    border-radius: 5px;
    padding: 15px;
    margin: 0 30px 30px 0;

    .title_box {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .title {
        color: #333;
        font-size: 17px;
        font-weight: bold;
      }
    }

    .img_box {
      width: 100%;
      display: flex;
      align-items: flex-start;
      padding: 20px 0;
      box-sizing: border-box;

      .img_styles {
        max-width: 420px;
        max-height: 140px;
        display: inline-block;
        vertical-align: middle;
      }

      .img_list_styles {
        width: 450px;
        margin: 10px auto;
        display: flex;
        align-items: center;
        justify-content: space-around;

        .img_list_styles_item {
          width: 80px;
          display: flex;
          flex-direction: column;
          align-items: center;

          img {
            display: block;
            width: auto;
            height: 80px;
          }

          .title {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 100%;
            margin-top: 10px;
            color: #333;
            font-size: 12px;
            text-align: center;
          }
        }
      }
    }

    .basic_item {
      margin-bottom: 12px;
      display: flex;
      align-items: center;
    }

    .basic_title {
      font-size: 14px;
      color: #333;
    }

    .basic_txt {
      color: #666;
      font-size: 14px;
    }

    .rotationChart_box {
      width: 400px;
      height: 200px;
      cursor: pointer;
      margin: 15px auto 0;

      /deep/ .ivu-carousel {
        width: 100%;
        height: 100%;

        .banner_img_box {
          width: 400px;
          height: 200px;
          background-color: #F7F7F7;
          overflow: hidden;
          position: relative;

          .banner_img {
            display: inline-block;
            width: 100%;
            height: auto;
          }

          .design_sketch_styles {
            color: #333;
            font-size: 17px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }

        .ivu-carousel-dots-inside {
          bottom: 18px;
        }

        .radius {
          width: 8px;
          height: 8px;
        }

        .ivu-carousel-active {
          .radius {
            background-color: #FD5425;
          }
        }

        .ivu-carousel-arrow {
          width: 24px;
          height: 32px;
          background: #000000;
          opacity: 0.4;
          display: flex;
          justify-content: center;
          align-items: center;

          .ivu-icon {
            font-size: 22px;
            color: #fff;
          }
        }

        .ivu-carousel-arrow.right {
          right: 0;
          border-radius: 4px 0px 0px 4px;
        }

        .ivu-carousel-arrow.left {
          border-radius: 0px 4px 4px 0px;
          left: 0;
        }
      }
    }
  }

  .advertising_box_item:nth-child(3n+3) {
    margin-right: 0;
  }
}
</style>